var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#F2F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9414 10.8359L13.9414 11.7821C13.9414 13.3499 15.2123 14.6208 16.78 14.6208C18.3478 14.6208 19.6187 13.3499 19.6187 11.7821V10.8359",
    stroke: "#D0006F",
    strokeWidth: 1.41931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1972 8H13.3628C11.5126 8 9.93361 9.33761 9.62945 11.1626L8.05243 20.6247C7.66794 22.9317 9.44697 25.0317 11.7858 25.0317H21.7742C24.113 25.0317 25.8921 22.9317 25.5076 20.6247L23.9306 11.1626C23.6264 9.33761 22.0474 8 20.1972 8Z",
    stroke: "#D0006F",
    strokeWidth: 1.41931,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniCart);
export default __webpack_public_path__ + "static/media/mini_cart.b74b629dd6f0db0fc65ad495c845eefc.svg";
export { ForwardRef as ReactComponent };